import React, { useEffect, useState } from 'react';
import PermissionForm from '../../../components/masters/users/permissions/PermissionForm';
import PermissionTable from '../../../components/masters/users/permissions/PermissionTable';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPermissions, addPermission, updatePermission, deletePermission, setEditingPermission, clearEditingPermission } from '../../../redux/actions/masters/users/permission/permissionAction';
import { showConfirm } from '../../../utills/sweetAlert';
import { fetchUsers } from '../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .permission-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .permission-form, .permission-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const PermissionPage = () => {
  const dispatch = useDispatch();
  const { list, loading, error, editingPermission } = useSelector((state) => state.permissions);
  const { list: users } = useSelector((state) => state.users);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchPermissions());
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleAddOrUpdate = async (permission) => {
    setFormSuccess('');
    setFormError('');
    if (editingPermission) {
      await dispatch(updatePermission({ id: editingPermission.permission_id, permission }));
      dispatch(clearEditingPermission());
      dispatch(fetchPermissions());
      setFormSuccess('Permission updated successfully!');
    } else {
      await dispatch(addPermission(permission));
      dispatch(fetchPermissions());
      setFormSuccess('Permission added successfully!');
    }
  };

  const handleEdit = (permission) => {
    dispatch(setEditingPermission(permission));
  };

  const handleDelete = async (id, module_name) => {
    const confirmed = await showConfirm('Delete Permission', `Are you sure you want to delete permission: ${module_name}?`, 'Delete', 'Cancel');
    if (confirmed) {
      dispatch(deletePermission(id));
    }
  };

  const handleCancelEdit = () => {
    dispatch(clearEditingPermission());
  };

  const handleNew = () => {
    dispatch(clearEditingPermission());
    setFormSuccess('');
    setFormError('');
    setFormResetKey(k => k + 1);
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="permission-flex">
        <div style={tableContainer} className="permission-table">
          {loading ? (
            <div>Loading...</div>
          ) : error ? (
            <div style={{ color: 'red' }}>{error}</div>
          ) : (
            <PermissionTable permissions={list} onEdit={handleEdit} onDelete={handleDelete} onNew={handleNew} />
          )}
        </div>
        <div style={formContainer} className="permission-form">
          <PermissionForm
            key={formResetKey}
            resetKey={formResetKey}
            onSubmit={handleAddOrUpdate}
            editingPermission={editingPermission}
            onCancel={handleCancelEdit}
            permissions={list}
            users={users}
            formSuccess={formSuccess}
            formError={formError}
            setFormSuccess={setFormSuccess}
            setFormError={setFormError}
          />
        </div>
      </div>
    </div>
  );
};

export default PermissionPage; 